'use client';

import {ContentSlider} from "@web-libs/ui/ui-components/slider/content-slider";
import {ContentSlide} from "@web-libs/ui/ui-components/slider/content-slider.types";
import {useTageaRouter} from "@web-libs/core/routing/application/use-tagea-router.concern";
import {routes} from "@web-app/[lang]/[tenant]/[institution]/routes-institution";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";

export type NewsSliderProps = {
    contentSlides: ContentSlide[];
}

export const NewsSlider = ({contentSlides}:NewsSliderProps) => {

    const dict = useDictionaryContext()

    const router = useTageaRouter();
    const navOnClick = (navId?: string) => navId? router.push(routes.publicInformation(navId)): null;

    return <ContentSlider onNavClick={navOnClick} topLeftText={dict.landingPage.slider_title} contentSlides={contentSlides} />
}
